import { render, staticRenderFns } from "./CurriculaSearch.vue?vue&type=template&id=0e548756"
import script from "./CurriculaSearch.vue?vue&type=script&lang=js"
export * from "./CurriculaSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports